import { zipCloudApiClient } from './apiClient/zipcloud';

export const getAddressByZipCode = async (zipCode, prefectureOptions) => {
  const { data } = await zipCloudApiClient.getAddress(zipCode);

  if (!data) {
    return null;
  }

  const { results } = data;
  if (!(results && results.length)) {
    return null;
  }

  const prefecture = findPrefectureByName(results[0].address1, prefectureOptions);

  return {
    prefectureId: prefecture ? prefecture.id : '',
    address1: results[0].address2 + results[0].address3,
  };
};

const findPrefectureByName = (prefectureName, prefectureOptions) => {
  return prefectureOptions.find(p => p.name === prefectureName);
};